import React from 'react';

const CARD = 'rounded-2xl bg-white shadow-sm ring-1 ring-gray-200/70 contrast-more:ring-gray-400';

/** What a lens shows while it loads, when it fails (an error with Try again, never an empty view) and when it is empty. */
export default function ViewState({ loading, error, onRetry, empty, children }: { loading: boolean; error: string | null; onRetry: () => void; empty?: string | null; children: React.ReactNode }) {
  if (error) {
    return (
      <div role="alert" className="flex flex-wrap items-center justify-between gap-3 rounded-2xl bg-rose-50 p-4 text-sm text-rose-800 ring-1 ring-rose-200">
        <span>{error}</span>
        <button type="button" onClick={onRetry} className="rounded-lg border border-rose-300 bg-white px-3 py-1.5 font-medium text-rose-800 hover:bg-rose-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-500">
          Try again
        </button>
      </div>
    );
  }
  if (loading) return <div className={`${CARD} p-8 text-center text-sm text-gray-600`}>Reading the plan…</div>;
  if (empty) return <div className={`${CARD} p-8 text-center text-sm text-gray-600`}>{empty}</div>;
  return <>{children}</>;
}
